<template>
    <div class="row">
        <div class="col-xl-12 individual-list__items-item" v-for="(product, index) in products" :key="product.ID">
            <a class="individual-list__items-item-remove-x" href="javascript:;">&#xd7;</a>
            <div class="individual-list__items-item-left">
                <div class="individual-list__items-item-wrapper">
                    <div class="individual-list__items-item-checkbox-wrapper" v-if="status !== 'recommendations'">
                        <label class="individual-list__items-item-checkbox">
                            <input type="checkbox" name="list-item" v-model="checkedProduct" v-bind:value="product" />
                            <span></span>
                        </label>
                    </div>
                    <div class="individual-list__items-item-img-wrapper">
                        <img class="individual-list__items-item-img" v-if="product.image_quick_reorder"
                            :src="product.image_quick_reorder" alt="Product Image" />
                        <img class="individual-list__items-item-img" v-else :src="
                            kadraGlobal.icons +
                            '/src/assets/images/plch.jpg'
                        " alt="Product Image" />
                    </div>
                </div>
            </div>
            <div class="individual-list__items-item-right">
                <div class="individual-list__items-item-left-wrapper">
                    <div class="individual-list__items-item-title-wrapper">
                        <span v-if="product.pa_brand" class="individual-list__items-item-title-pretitle"
                            v-html="product.pa_brand"></span>
                        <span v-else class="individual-list__items-item-title-pretitle">-</span>
                        <a class="individual-list__items-item-title-title" :href="product.url" v-html="product.title"></a>
                        <a class="individual-list__items-item-title-remove" href="javascript:;"
                            v-if="status !== 'recommendations'" @click="removeItem(product)">Remove</a>
                    </div>
                    <div class="individual-list__items-item-details-wrapper">
                        <span class="individual-list__items-item-details-title">Size, color & sku</span>
                        <span class="individual-list__items-item-details-info" v-if="product.pa_size && product.pa_color"
                            v-html="product.pa_size + ' | ' + product.pa_color"></span>
                        <span class="individual-list__items-item-details-info"
                            v-else-if="product.pa_size && !product.pa_color" v-html="product.pa_size"></span>
                        <span class="individual-list__items-item-details-info"
                            v-else-if="!product.pa_size && product.pa_color" v-html="product.pa_color"></span>
                        <span class="individual-list__items-item-details-info" v-html="'SKU: ' + product.sku"></span>
                    </div>
                    <div class="individual-list__items-item-packs-wrapper">
                        <span class="individual-list__items-item-packs-title">Pieces & Case pack</span>
                        <span v-if="product.case_pack" class="individual-list__items-item-packs-info" v-html="
                            'Case Pack of ' + product.case_pack + ' units'
                        "></span>
                    </div>
                </div>
                <div class="individual-list__items-item-right-wrapper">
                    <div class="individual-list__items-item-quantity-wrapper">
                        <span class="individual-list__items-item-quantity-title">Quantity</span>
                        <div class="individual-list__items-item-quantity-contaner" v-if="CanOrder(product)">
                            <span
                                class="individual-list__items-item-quantity-toggle individual-list__items-item-quantity--minus js-input-increment-minus"
                                @click="
                                    removeFromCart(
                                        product.ID,
                                        index,
                                        product.case_pack
                                    )
                                "></span>
                            <input
                            class="individual-list__items-item-input"
                            :disabled="activeIndex2 === index"
                            type="text"
                            :value="GetFormattedQty(product.ID)"
                            ref="inputQy"
                            v-on:keyup="onEnter(product.ID,index,product.case_pack,$event)"
                            min="0"
                            @input="updateValue"
                            maxlength="5"
                            placeholder="0"
                            @focus="handleFocus(product.id)"
                            @blur="handleBlur"
                            />
                            <span v-if="checkCart(product)"
                                class="individual-list__items-item-quantity-toggle individual-list__items-item-quantity--plus js-input-increment-plus"
                                @click="
                                    addToCart(
                                        product.ID,
                                        index,
                                        product.case_pack
                                    )
                                "></span>
                        </div>

                        <div v-if="!CanOrder(product)">
                            Not available
                        </div>
                        <template v-else-if="activeIndex2 !== index">
                            <span v-if="cart[product.ID]"
                                class="cart__items-item-quantity-cases cart__items-item-quantity-cases--has-item">Units in
                                cart</span>
                            <span v-else class="product-info-box__total-cases">Units in cart</span>
                        </template>
                        <span v-if="activeIndex2 === index"
                            class="product-info-box__total-quantity-loader">Processing...</span>
                    </div>
                    <div class="individual-list__items-item-price-wrapper">
                        <span class="individual-list__items-item-price-title">Price per unit</span>
                        <span v-if="product.price !== product.price_reg" class="individual-list__items-item-price individual-list__items-item-price--sale" style="text-decoration:line-through">
                            <sup>$</sup>{{ product.price_reg || 0}}
                        </span>
                        <span class="individual-list__items-item-price">
                            <sup>$</sup>{{ product.price || 0 }}
                        </span>
                    </div>
                    <div class="individual-list__items-item-total-wrapper">
                        <span class="individual-list__items-item-total-title">Total Price</span>
                        <span class="individual-list__items-item-total">
                            <sup>$</sup>{{ setTotalPrice(cart[product.ID], product.price, product.case_pack) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'products',
        'isCheckAll',
        'wishlist',
        'status',
        'cart',
        'addToCartLoading',
        'kadraGlobal',
        'removeCheckedProduct'
    ],
    data() {
        return {
            checkedProduct: [],
            activeIndex2: undefined,
            inputDelay: null,
            CartQty: [],
            AddToCartTimeouts: {}
        };
    },
    watch: {
        checkedProduct() {
            this.$emit('checkedProducts', this.checkedProduct);
        },
        isCheckAll() {
            if (this.isCheckAll) {
                const products = [];
                this.products.forEach(element => {
                    products.push(element);
                });
                this.checkedProduct = products;
            } else {
                this.checkedProduct = [];
            }
        },
        addToCartLoading() {
            if (!this.addToCartLoading) {
                this.activeIndex2 = undefined;
            }
        },
        removeCheckedProduct() {
            this.checkedProduct = [];
        },
        cart() {
            this.UpdateCartQty();
        }
    },
    methods: {
        updateValue(event) {
            let val = event.target.value;
            const max = event.target.maxLength;

            val = val.replace(/[^0-9]/g, '');

            if (val.length > max) {
                val = val.slice(0, max);
            }

            // If the input is empty, treat it as 0
            if (val.trim() === '') {
                val = '0';
            }

            event.target.value = val;
        },
        handleFocus(id) {
            this.focusedInput = id;
        },
        handleBlur() {
            this.focusedInput = null;
        },
        removeItem(product) {
            this.$store.dispatch('removeManyFromWishlist', {
                arr: [product],
                wish_id: this.wishlist.ID
            });
        },
        // increase qty
        addToCart(id, index, pack) {
            this.CartQty[id] = (parseInt(this.CartQty[id]) || 0) + 1;
            this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
        },
        // decrease qty
        removeFromCart(id, index, pack) {
            this.CartQty[id] = Math.max(
                0,
                (parseInt(this.CartQty[id]) || 0) - 1
            );
            this.DelayedUpdateQty(id, index, pack, this.CartQty[id]);
        },
        // on qty input change
        onEnter(id, index, pack, event) {
            const val = event.target.value.trim() === '' ? 0 : parseInt(event.target.value) || 0;
            if (val < 0) {
                event.target.value = '';
                return false;
            }
            this.CartQty[id] = val;
            this.DelayedUpdateQty(id, index, pack, val);
        },
        // delayed send qty to WC
        DelayedUpdateQty(ProductId, Index, Pack, Value) {
            if (this.AddToCartTimeouts[ProductId]) {
                clearTimeout(this.AddToCartTimeouts[ProductId]);
            }
            this.AddToCartTimeouts[ProductId] = setTimeout(() => {
                if (Index !== null) {
                    this.activeIndex2 = Index;
                }
                this.$store.dispatch('addMany', {
                    id: ProductId,
                    val: Value,
                    pack: Pack
                });
            }, 500);
        },
        // nice formatted qty value
        GetFormattedQty(ProductId) {
            return this.CartQty[ProductId] === 0 ? '' : (parseInt(this.CartQty[ProductId]) || '');
        },
        // clone qtys from store to local variable
        UpdateCartQty() {
            this.CartQty = { ...this.cart };
        },
        checkCart() {
            return true;
        },
        CanOrder(product) {
            // disable if price is zero or missing
            const Price = parseFloat(product.price);
            if (
                isNaN(Price) ||
                Price <= 0
            ) {
                return false;
            }
            return true;
        },
        setTotalPrice(qty, price, pack) {
            if (qty === undefined) {
                return 0;
            } else {
                const sum = parseInt(qty); /* * parseInt(pack)*/
                if (sum === 0 || isNaN(sum)) {
                    return 0;
                }
                const Total = sum * parseFloat(price); // price also can be NaN
                return isNaN(Total) ? '0' : Total.toFixed(2);
            }
        }
    },
    mounted() {
        this.UpdateCartQty();
    }
};
</script>

<style lang="scss" scoped>
.product-info-box__total-quantity-out {
    @include mq(692px) {
        margin-top: 20px;
    }
}

.individual-list__items-item-img {
    max-width: 50px;
}

.individual-list__items-item-price--sale {
    font-size: 11px;
    font-weight: 400;
    font-family: $font-main;
    margin-bottom: 2px;
    display: block;
}

.individual-list__items-item-input {
    &::placeholder {
        color: $white;
    }

    &:focus {
        &::placeholder {
            color: transparent !important;
        }
    }
}
</style>
